import { PlainButton } from "@jugl-web/ui-components/cross-platform/PlainButton";
import { Text } from "@jugl-web/ui-components/cross-platform/Text";
import { cx } from "@jugl-web/utils";
import { ButtonHTMLAttributes, ReactNode, forwardRef } from "react";

export interface ControlBarButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  startSlot?: ReactNode;
  endSlot?: ReactNode;
  isActive?: boolean;
}

export const ControlBarButton = forwardRef<
  HTMLButtonElement,
  ControlBarButtonProps
>(({ label, startSlot, endSlot, isActive, className, ...props }, ref) => (
  <PlainButton
    ref={ref}
    className={cx(
      "jugl__focusable-outline flex h-[40px] min-w-[40px] shrink-0 items-center justify-center gap-2 rounded-lg px-2 text-[#828282] transition-colors hover:bg-white",
      isActive && "bg-white",
      className
    )}
    {...props}
  >
    {startSlot}
    {label && (
      <Text variant="body3" className="text-dark-800 truncate">
        {label}
      </Text>
    )}
    {endSlot}
  </PlainButton>
));
